<template>
  <div class="">
    <div class="mobile">
      <div class="header">
        <p class="title">
          <i class="menuIcon el-icon-s-unfold" @click="showDrawer"></i>
          昌恩暖通智控节能项目投资回报预算系统
        </p>

        <el-button class="newBudget" type="primary" @click="newBudget"
          >创建用户</el-button
        >
      </div>

      <el-card class="box-card set-scroll">
        <el-table
          :data="tableData"
          style="width: 100%"
          @row-click="clickToManagementDeatils"
        >
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">
              {{
                scope.$index + 1 + (pageData.pageNum - 1) * pageData.pageSize
              }}
            </template>
          </el-table-column>

          <el-table-column
            prop="userName"
            label="用户名"
            min-width="90"
          ></el-table-column>
          <!-- <el-table-column
          prop="passWord"
          label="密码"
          min-width="100%"
        ></el-table-column> -->

          <el-table-column prop="create_Time" label="创建时间" min-width="160">
          </el-table-column>

          <el-table-column label="操作" min-width="70">
            <template slot-scope="scope">
              <el-button
                icon="el-icon-edit"
                @click.stop="changePassword(scope.row)"
                type="text"
                size="small"
                >密码
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.pageNum"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="pageData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalPage"
        >
        </el-pagination>
      </el-card>

      <!-- 修改密码弹框  -->
      <myDialog
        title="修改密码"
        :dialogVisible="changePwDialogVisible"
        :currentUserName="currentUserName"
        @closeDialog="closeChangPwDialog"
        @commitChangePw="commitChangePw"
      ></myDialog>

      <!-- 新建用户弹框 -->
      <el-dialog
        append-to-body
        title="新建用户"
        :visible.sync="dialogVisible"
        width="90%"
        :before-close="handleClose"
        class="custom-dialog"
      >
        <el-form
          :model="createAccountForm"
          ref="createAccountForm"
          class="custom-from"
        >
          <el-form-item
            label="用户名称："
            required
            :rules="[
              { required: true, message: '请输入用户名称', trigger: 'blur' }
            ]"
            prop="userName"
          >
            <el-input
              placeholder="请输入用户名称"
              v-model="createAccountForm.userName"
            ></el-input>
          </el-form-item>

          <el-form-item
            class="createUserPassword"
            label="用户密码："
            required
            :rules="[
              { required: true, message: '请输入用户密码', trigger: 'blur' }
            ]"
            prop="passWord"
          >
            <el-input
              placeholder="请输入用户密码"
              v-model="createAccountForm.passWord"
            ></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button class="cancel-btn" @click="colseDialog">取 消</el-button>
          <el-button type="primary" @click="confirmDialog">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 菜单抽屉 -->
      <menuDrawer
        :drawerVisible="drawerVisible"
        @closeDrawer="closeDrawer"
      ></menuDrawer>
    </div>
  </div>
</template>

<script>
import myDialog from '@/views/mobile/components/changePwDialog.vue'
import menuDrawer from '@/views/mobile/components/menuDrawer.vue'
import { getUserAll, register, update } from '@/api/home/index'
export default {
  components: { myDialog, menuDrawer },
  data () {
    return {
      dialogVisible: false,
      createAccountForm: { userName: '', passWord: '' },
      tableData: [],
      totalPage: 0,
      pageData: {
        userName: JSON.parse(localStorage.getItem('userInfo')).userName,
        pageSize: 12,
        pageNum: 1
      },
      drawerVisible: false,
      changePwDialogVisible: false,
      currentUserName: ''
    }
  },
  mounted () {
    this.getUserData()
  },
  methods: {
    async getUserData () {
      try {
        const res = await getUserAll(this.pageData)
        if (res.code == 0) {
          console.log('账号', res)
          this.tableData = res.data.total
          this.totalPage = res.data.data
        }
      } catch (error) {}
    },
    clickToManagementDeatils (row) {
      console.log('点击项id', row)
      this.$router.push({
        path: '/userManagementDetails',
        query: {
          id: row.id,
          userName: row.userName
        }
      })
    },

    // 修改密码click事件
    changePassword (row) {
      console.log('change')
      this.changePwDialogVisible = true
      this.currentUserName = row.userName
      // this.dialogTitle = '修改密码'
    },

    // 修改密码弹框：提交修改
    async commitChangePw (data) {
      let arg = {
        userName: this.currentUserName,
        passWord: data.passWord
      }
      const res = await update(arg)
      console.log('接口', res)
      if (res.code == 0) {
        this.$message({
          type: 'success',
          message: res.message
        })
      } else {
        this.$message({
          type: 'error',
          message: res.message
        })
      }
      this.getUserData()
    },
    closeChangPwDialog () {
      this.changePwDialogVisible = false
    },

    // 弹框
    newBudget () {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.createAccountForm.resetFields()
      })
    },
    handleClose () {
      this.dialogVisible = false
      this.$refs.createAccountForm.resetFields()
    },
    confirmDialog () {
      this.$refs.createAccountForm.validate(async valid => {
        if (valid) {
          this.dialogVisible = false
          try {
            const res = await register(this.createAccountForm)
            console.log('接口', res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: res.message
              })
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
            this.getUserData()
          } catch (error) {}
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    colseDialog () {
      this.dialogVisible = false
      this.$refs.createAccountForm.resetFields()
    },

    handleSizeChange () {},
    handleCurrentChange (page) {
      this.pageData.pageNum = page
      this.getUserData(this.pageData)
      console.log('选择页码', page)
    },

    // 抽屉
    showDrawer () {
      this.drawerVisible = true
    },
    closeDrawer () {
      this.drawerVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
// .container {
//   // height: calc(100% - 70px);
//   // padding: 10px 16px;
// }
.mobile {
  padding: 0 0.5em;
  .header .title {
    margin: 0px 20px 20px 0;
    padding-bottom: 10px;
    text-align: left;
    color: rgba(@homeBoxColor, 0.9);
    font-weight: 700;
    font-size: 5em;
    padding: 60px 60px 60px 0;
    // text-align: center;
    display: flex;
    align-items: center;
    .menuIcon {
      font-size: 1.8em;
      margin-right: 0.5em;
    }
  }

  .newBudget {
    width: 100%;
    margin: 0 auto;
    font-size: 6em;
    margin-bottom: 0.5em;
    border-radius: 0.1em;
    padding: 0.5em;
  }
  .box-card {
    height: calc(100vh - 580px);
    // height: calc(100vh - 600px);
    overflow: auto;
  }
  ::v-deep .cell {
    font-size: 2em;
    padding: 1em 0.6em;
  }

  ::v-deep .el-table .el-table__cell {
    font-size: 2.5em;
  }

  ::v-deep .el-table .el-table__cell .el-button {
    font-size: 1em;
  }

  .el-pagination {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 4em;
    margin-bottom: 4em;

    ::v-deep .el-pagination__total,
    ::v-deep .btn-next .el-icon,
    ::v-deep .btn-prev .el-icon,
    ::v-deep .el-pagination__jump {
      font-size: 4em;
    }

    ::v-deep .el-pager li {
      font-size: 76px;
      font-weight: normal;
      height: 76px;
      line-height: 76px;
    }
    ::v-deep .btn-prev,
    ::v-deep .btn-next {
      font-size: 1.3em;
      display: flex;
      align-items: center;
      height: auto;
    }
    ::v-deep .el-pagination__jump {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 8em;
    }
    ::v-deep .el-pagination__editor.el-input {
      width: 16em;
    }
    ::v-deep .el-input__inner {
      color: orange;
      font-size: 5em;
      padding: 0.6em 0.2em;
      width: 2em;
      height: 1em;
      margin-top: -0.5em;
    }
  }
}
</style>

<style lang="less">
.mobile .dialog-batch .el-dialog__body {
  max-height: none;
  padding: 6em;
}

.custom-dialog {
  .el-dialog__header {
    // height: 10em;
    // background: red;
    border-bottom: 2px solid #ccc;
    padding: 3em;
    .el-dialog__title {
      font-size: 5em;
      line-height: 1;
    }
  }
  .el-dialog__body {
    padding: 10em 0;
  }
  .el-dialog__footer {
    padding: 2em;
  }
}

.custom-from {
  .el-form-item__label {
    font-size: 5em;
    width: 7em;
  }
  .el-input__inner {
    font-size: 5em;
    padding: 0.8em 0.5em;
  }
  .el-form-item {
    display: flex;
    align-items: center;
    justify-content: start;
  }
  .el-form-item__content {
    margin-right: 2em;
    flex: 1;
  }
  .el-form-item__error {
    font-size: 3em;
    padding-left: 0.8em;
    padding-top: 0.5em;
  }
}

.dialog-footer {
  .el-dialog__footer {
    text-align: center !important;
  }
  .el-button {
    font-size: 4em;
    padding: 0.6em;
    border-radius: 0.2em;
    margin: 0.6em;
  }
  .cancel-btn {
    margin-right: 1em;
  }
}

@media screen and (max-width: 768px) {
  // 修改弹框样式
  .el-message .el-icon-success,
  .el-message .el-icon-error {
    font-size: 18px !important;
    padding-left: 10px;
  }

  .el-message--success .el-message__content,
  .el-message--error .el-message__content {
    font-size: 18px !important;
    padding: 6px 10px 6px 0;
  }

  .createUserPassword {
    margin-top: 7em !important;
  }
}
</style>
